import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { Observable } from 'rxjs/Observable';
import { User } from '../model/user.class';
import { AuthHttp } from 'angular2-jwt/angular2-jwt';
import { Publisher } from '../model/publisher.class';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-publisher-new',
    templateUrl: './publisher.new.component.html'
})
export class PublisherNewComponent {

    public name: string;
    public ratemodel: string;
    public contact: string;
    public maxVideoSize: number;

    public message = '';

    constructor(public userService: UserService, private route: ActivatedRoute, private router: Router) {}

    createPublisher() {
        const publisher = new Publisher(this.name, this.ratemodel, this.contact, this.maxVideoSize);
        this.userService.create(publisher, 'publisher').subscribe(
            () => {
                this.router.navigate(['/publisher/list']);
            },
            (err) => {
                this.message = 'Alle Pflichtfelder ausfüllen!';
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/publisherNew/publisher.new.component.ts